export const keys = {
  token: 'token',
  isAdmin: 'isAdmin',
  flowType: 'flowType',
  termsDisclaimer: 'termsDisclaimer',
  marketingPreferencesSaved: 'marketingPreferencesSaved',
  email: 'email',
  agencyNumber: 'agencyNumber',
  lenderNameId: 'lenderNameId',
};
